import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface MarkEmailVerifiedResponse extends BackendResponse {}

export interface MarkEmailVerifiedParameters extends NextApiParams {
  email: string;
  code: string;
}

export const markEmailVerified = withNextApi<
  MarkEmailVerifiedResponse,
  MarkEmailVerifiedParameters
>("/auth/MarkEmailVerified");
